import { useSyncExternalStore } from "react";

// Летящие зонтики поверх панели — украшение, которое включается в настройках.
// Хранится там же, где шрифт и тема: в браузере, по одному выбору на
// устройство. По умолчанию выключено: эффект хорош как настроение, но не
// должен появляться у человека сам собой.
//
// Значения: "off" — ничего, "umbrellas" — зонтики из знака панели.
const STORAGE_KEY = "kl-ambient-effect";
const MODES = ["off", "umbrellas"];

const read = () => {
  if (typeof window === "undefined") return "off";
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return MODES.includes(stored) ? stored : "off";
  } catch (_) { return "off"; }
};

let current = read();
const listeners = new Set();

export const getAmbientMode = () => current;

export const setAmbientMode = (mode) => {
  const next = MODES.includes(mode) ? mode : "off";
  if (next === current) return;
  current = next;
  try { window.localStorage.setItem(STORAGE_KEY, next); } catch (_) { /* приватный режим */ }
  listeners.forEach((listener) => { try { listener(); } catch (_) { /* слушатель сам разберётся */ } });
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useAmbientMode = () => useSyncExternalStore(subscribe, getAmbientMode, getAmbientMode);
